import React, { Component } from 'react';
/* Components */
import LoadingModal from '../common/loadingModal';
import ExtendedPropertyCreator from '../common/extended_property/extendedPropertyCreator';

class ModalCreate extends Component {
  constructor(props) {
    super(props);
    const obj = {};
    props.datosDatasource.forEach(item => {
      obj[item.alias] = '';
      obj[`id-${item.alias}`] = '';
    });
    this.state = obj;
  }

  componentWillReceiveProps(nextProps) {
    this.props.config.hom.forEach(item => {
      this.setState({ [item.dataSource]: '' });
      this.setState({ [`id-${item.dataSource}`]: '' });
    });

    nextProps.config.hom.forEach(item => {
      this.setState({ [item.dataSource]: item.externalEntityId });
      this.setState({ [`id-${item.dataSource}`]: item.id });
    });
  }

  handleChange = e => {
    this.setState({
      [e.target.dataset.type]: e.target.value
    });
  };

  render() {
    return (
      <div
        data-close="ok"
        onClick={this.props.handleModal}
        className={this.props.modal ? `container-modal` : `container-modal hide`}
      >
        <section className="module-title modal-title">
          <h2>{this.props.language.account.homologationDriver.createVehicule}</h2>
          {this.props.statusSave == 500 &&
            this.props.dataSave.error.params.map((item, i) => (
              <p key={i} className="error">
                {this.props.language.error[`cod${item.messageCode}`]}{' '}
              </p>
            ))}
          <a>
            <i data-close="ok" onClick={this.props.handleModal} className="fas fa-times-circle" />
          </a>
        </section>
        {this.props.statusSave != 200 && (
          <div className={`box-modal max500`}>
            <section id="modal-create" className="base-form">
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.homologationDriver.name} <strong>(*)</strong>
                  </label>
                </div>
                <div>
                  <input
                    data-update="name"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.config.name}
                    type="text"
                    id="nameup"
                    className="modal-input"
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.homologationDriver.code} <strong>(*)</strong>{' '}
                    <span className="help">
                      <i className="fas fa-question-circle" />
                      <div>{this.props.language.account.help.codeVehicle}</div>
                    </span>
                  </label>
                </div>
                <div>
                  <input
                    data-update="code"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.config.code}
                    type="text"
                    id="codeup"
                    className="modal-input"
                  />
                </div>
              </div>
              <ExtendedPropertyCreator
                prefix="create-"
                extendedPropertiesValue={null}
                extendedProperties={this.props.extendedProperties}
              />
              {this.props.filter.length > 0 && (
                <div className="module-title left">
                  <h2>
                    {this.props.language.account.others.categories} <strong>(*)</strong> <p>{this.props.language.account.others.selectOneItem}</p>
                  </h2>
                </div>
              )}
              {this.props.filter.map((item, i) => (
                <div className="box-form islabel" key={`tags-${i}`}>
                  <div>
                    <label className="modal-label">
                      {this.props.language.filter[item.name.toLowerCase()]}
                    </label>
                  </div>
                  <div>
                    <ul className="multiple-select" data-listup={`list-${i}`}>
                      {item.tags.map((item, e) => (
                        <li
                          className={this.props.config.tags.includes(item.tag) ? 'select' : ''}
                          onClick={this.props.handleSelect}
                          data-parentup={`list-${i}`}
                          id={`listup-${i}-${e}`}
                          key={`list-${i}-${e}`}
                        >
                          {item.tag}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
              <div className="module-title left">
                <h2>{this.props.language.account.homologationDriver.dataSource}</h2>
                <p>{this.props.language.account.homologationDriver.dataSourceDescent}</p>
              </div>
              {this.props.datosDatasource.map((item, i) => {
                return (
                  <div key={i} className="box-form islabel flex align-center top ">
                    <div className="width100">
                      <label className="modal-label padding-reset">{item.alias}:</label>
                    </div>
                    <div>
                      <input
                        onChange={this.handleChange}
                        value={this.state[item.alias]}
                        data-homup={`hom-${i}`}
                        data-id={this.state[`id-${item.alias}`]}
                        data-type={`${item.alias}`}
                        autoComplete="off"
                        type="text"
                        id={`homup-${i}`}
                        className="modal-input"
                      />
                    </div>
                  </div>
                );
              })}
            </section>
          </div>
        )}
        {this.props.statusSave != 200 && (
          <div className={'box-form islabel top center modal-button-box '}>
            <div>
              {this.props.loadingSave ? (
                <div className="spiner">
                  <i className="fas fa-spinner fa-spin" /> {this.props.language.account.others.loading}
                </div>
              ) : (
                <input
                  className="active"
                  onClick={this.props.handleSubmit}
                  type="button"
                  value={this.props.language.account.homologationDriver.createTeam}
                />
              )}
            </div>
          </div>
        )}
        {this.props.statusSave == 200 && (
          <div className={`box-modal max500`}>
            <section
              className={this.props.dataSave.homologations ? 'feed-back green' : 'feed-back yellow'}
            >
              <div>
                <i className="fas fa-check-circle" />
              </div>
              <div>
                <p>
                  {this.props.dataSave.homologations
                    ? this.props.language.account.homologationDriver.feedBackDriverOk
                    : this.props.language.account.homologationDriver.feedBackDriverWarning}
                </p>
              </div>
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default ModalCreate;



// WEBPACK FOOTER //
// ./source/client/components/homologation_vehicle/modalCreate.jsx